import { NavigationContainer as NavContainer } from '@react-navigation/native';
import { navigationRef } from './RootNavigation';
import { setVisibilityAsync } from 'expo-navigation-bar';
import { PropsWithChildren } from 'react';
import { reactNavigationIntegrationForSentry } from '..';
import { setTag } from '@sentry/react-native';
import { IS_ANDROID } from '@/utils/platform';
import { logError } from '@/utils/logHandling';

const hideNavigationBar = async () => {
  try {
    await setVisibilityAsync('hidden');
  } catch (e: any) {
    logError('Failed to hide navigation bar', e);
  }
};

export function NavigationContainer({ children }: PropsWithChildren) {
  return (
    <NavContainer
      onReady={async () => {
        reactNavigationIntegrationForSentry.registerNavigationContainer(
          navigationRef,
        );
        const route = navigationRef.getCurrentRoute()?.name;
        if (route) {
          setTag('route', route);
        }
        await hideNavigationBar();
      }}
      onStateChange={async (state) => {
        const route = navigationRef.getCurrentRoute()?.name;
        if (route) {
          setTag('route', route);
        }
        if (!IS_ANDROID || !state) {
          return;
        }

        await hideNavigationBar();
      }}
      ref={navigationRef}
    >
      {children}
    </NavContainer>
  );
}
